export const Global = {
 //API_URL: "http://localhost:5000/api/",
   //PHOTO_URL: "http://localhost:5000/Uploads/",
  API_URL: "https://api.playmegastorelb.com/api/",
 PHOTO_URL: "https://api.playmegastorelb.com/Uploads/",
};